import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { PushService } from './push.service';
import * as moment from 'moment';

@Injectable()
export class SettingService {
    constructor(
        private http: HttpService,
        private pushSvc: PushService
    ) { // , private platformService: PlatformService
    }

    init() { // 서버의 db에 접속하여 세팅 정보가 있으면 기존 세팅 정보를 유지하고 없으면 default setting파일을 생성한다.
        this.http.post({url: 'init-setting', params: {}}).then(() => {
        });
    } // init: function() {


    update(obj: any, callback: (body: any) => void) {

        obj.flag = obj.flag === true ? 'on' : 'off';
        const params: any = {k: obj.option, v: obj.flag};

        if (obj.option === 'enableTime') {
            params.Stimer = moment(obj.Stimer).format('HH: mm');
            params.Etimer = moment(obj.Etimer).format('HH: mm');
        }


        // 푸시알림(전체) on/off 일경우 카카오 api에서 삭제한다.

        if (obj.option === 'all') {
            switch (obj.flag) {
                case 'on': this.pushSvc.setTokenToServer(); break;
                case 'off': this.pushSvc.removeTokenFromServer(); break;
            }
        }

        this.http.get({url: 'update-setting', params}).then((res) => {
            callback(res);
        });



    } // update: function()

    getSetting(callback: (body: any) => void) {
        const setData: any = {all: false, enableTime: false, powerLadderResult: false};

        this.http.get({url: 'get-setting'}).then((obj) => {

            if (typeof (obj.setting) === 'undefined') { obj.setting = {}; }

            setData.all = obj.setting.all === 'off' ? false : true; // 푸시알림(전체)
            setData.enableTime = obj.setting.enableTime === 'off' ? false : true; // 알림시간 설정
            setData.diceResult = obj.setting.diceResult === 'off' ? false : true; // 파워사다리 > 게임결과
            setData.fourteenResult = obj.setting.fourteenResult === 'off' ? false : true; // 파워사다리 > 게임결과
            setData.fiftyResult = obj.setting.fiftyResult === 'off' ? false : true; // 파워사다리 > 게임결과

            setData.powerLadderResult = obj.setting.powerLadderResult === 'off' ? false : true; // 파워사다리 > 게임결과
            setData.powerLadderFeed = obj.setting.powerLadderFeed === 'off' ? false : true; // 파워사다리 > 구독
            setData.powerballResult = obj.setting.powerballResult === 'off' ? false : true; // 파워볼 > 게임결과
            setData.powerballFeed = obj.setting.powerballFeed === 'off' ? false : true; // 파워볼 > 구독
            setData.ladderResult = obj.setting.ladderResult === 'off' ? false : true; // 사다리 > 게임결과
            setData.ladderFeed = obj.setting.ladderFeed === 'off' ? false : true; // 사다리 > 구독
            setData.dariResult = obj.setting.dariResult === 'off' ? false : true; // 다리다리 > 게임결과
            setData.dariFeed = obj.setting.dariFeed === 'off' ? false : true; // 다리다리 > 구독

            setData.newfollower = obj.setting.newfollower === 'off' ? false : true; // 뉴 팔로워 알림
            setData.pattern = obj.setting.pattern === 'off' ? false : true; // 패턴알림
            setData.notice = obj.setting.notice === 'off' ? false : true; // 공지사항
            setData.soundEnable = obj.setting.soundEnable === 'off' ? false : true; // 사운드
            setData.vibrationEnable = obj.setting.vibrationEnable === 'off' ? false : true; // 진동

            const nowDateTime = new Date();
            setData.Stimer = new Date(nowDateTime.getFullYear(), nowDateTime.getMonth(), nowDateTime.getDate(), nowDateTime.getHours(), nowDateTime.getMinutes(), 0); // 2017, 0, 1, 14, 57, 0
            setData.Etimer = new Date(nowDateTime.getFullYear(), nowDateTime.getMonth(), nowDateTime.getDate(), nowDateTime.getHours(), nowDateTime.getMinutes(), 0);

            if (obj.setting.Stimer) {
                const Stimer = obj.setting.Stimer.split(': ');
                nowDateTime.setHours(Stimer[0]);
                nowDateTime.setMinutes(Stimer[1]);
                setData.Stimer = new Date(nowDateTime.getFullYear(), nowDateTime.getMonth(), nowDateTime.getDate(), nowDateTime.getHours(), nowDateTime.getMinutes(), 0);
            }
            if (obj.setting.Etimer) {
                const Etimer = obj.setting.Etimer.split(': ');
                nowDateTime.setHours(Etimer[0]);
                nowDateTime.setMinutes(Etimer[1]);
                setData.Etimer = new Date(nowDateTime.getFullYear(), nowDateTime.getMonth(), nowDateTime.getDate(), nowDateTime.getHours(), nowDateTime.getMinutes(), 0);
            }
            callback(setData);
        });

    }
}
